namespace RedBullMOBILE360.CustomerCare {
    export namespace LineTerminationReportService {
        export const baseUrl = 'CustomerCare/LineTerminationReport';

        export declare function Create(request: Serenity.SaveRequest<LineTerminationReportRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<LineTerminationReportRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<LineTerminationReportRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<LineTerminationReportRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "CustomerCare/LineTerminationReport/Create",
            Update = "CustomerCare/LineTerminationReport/Update",
            Delete = "CustomerCare/LineTerminationReport/Delete",
            Retrieve = "CustomerCare/LineTerminationReport/Retrieve",
            List = "CustomerCare/LineTerminationReport/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>LineTerminationReportService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
